﻿﻿/// <reference path="Definitions/jquery.d.ts" />

import * as $ajax from './_ajax'
import * as $form from './_form'
import * as $helpers from './_helpers'
import * as $loading from './_loading'
import * as $notifications from './_notifications'
import * as $modal from './_modal'
import * as $msg from './_msg'
import * as $resources from './_resources'
import * as $table from './_table'

export function makeCaptchaReloadable(img: JQuery): void {
    var urlBase = img.attr('data-src')
    img.click(function () {
        img.attr('src', urlBase + '&rnd=' + new Date().getTime())
    })
}

export function currentPageSize(): string {
    var mode = 'xxs'
    if ($('#bcfla-helper-visible-xs').is(':visible')) {
        mode = 'xs'
    } else if ($('#bcfla-helper-visible-sm').is(':visible')) {
        mode = 'sm'
    } else if ($('#bcfla-helper-visible-md').is(':visible')) {
        mode = 'md'
    } else if ($('#bcfla-helper-visible-lg').is(':visible')) {
        mode = 'lg'
    }
    return mode
}

export function partialPageInit(targetControl: JQuery) {
    console.log('partialInit')
    console.log(targetControl)

    targetControl.find('.bcfla-table-expand-togglebtn').click(function () {
        $table.toggleExpand(this, $(this).attr('data-trclass'))
    })

    targetControl.find('.bcfla-table-row2-togglebtn').click(function () {
        $table.toggleRow2Table($(this).attr('data-tableclass'))
    })

    targetControl.find('.bcfla-tr-row2-toggle').click(function () {
        $table.toggleRow2Tr($(this).attr('data-trclass'))
    })

    targetControl.find('.bcfla-tooltip').tooltip({ delay: 300, html: true, placement: 'top' })
    targetControl
        .find('.bcfla-tooltip-click')
        .tooltip({ delay: 300, html: true, placement: 'top', trigger: 'click' })

    targetControl.find('.bcfla-msg').each(function () {
        $(this).click(function () {
            var okmsg: string = $(this).attr('data-msg-ok')
            var errmsg: string = $(this).attr('data-msg-err')

            if (okmsg && okmsg.length > 0) $msg.show(okmsg)
            else if (errmsg && errmsg.length > 0) $msg.showError(errmsg)
        })
    })

    targetControl.find('.bcfla-datepicker').datepicker({ dateFormat: 'yy-mm-dd' })

    $form.bindCheckboxEvents(targetControl)
    makeUnRightClickable(targetControl)
}

export function loadPartial(options: any) {
    $loading.show($resources.text.loadingPage)

    $ajax.get({
        url: options.url,
        success: (res) => {
            $loading.hide()
            options.targetControl.html(res)
            partialPageInit(options.targetControl)
        },
        dataType: 'html',
    })
}

function makeUnRightClickable(targetControl: JQuery): void {
    targetControl.find('.bcfla-unrightclickable').on('mousedown click', function (event) {
        if (event.button == 2) {
            return false
        }
    })
    targetControl.find('.bcfla-unrightclickable').on('contextmenu', function () {
        return false
    })
}

export function pageInit(webFont: any, kontoId: number): void {
    webFont.load({
        google: {
            families: ['Open Sans:100,300,400,700', 'Raleway:100,300,400,700'],
        },
        active: function () {},
    })

    $.fn.addSelectOptions = function (
        json: any,
        valueParam: string = 'Key',
        labelParam: string = 'Label'
    ) {
        return this.each(function () {
            if (this.nodeName.toLowerCase() != 'select') return

            var opt = ''
            for (var i = 0; i < json.length; i++) {
                opt +=
                    '<option value="' +
                    json[i][valueParam] +
                    '">' +
                    json[i][labelParam] +
                    '</option>'
            }

            $(this).html(opt)
        })
    }

    $('#bcfla-sidenav-overlay').click(function () {
        sidenav.hide()
    })

    $('#bcfla-modal-button-stang, #bcfla-modal-overlay').click(function () {
        $modal.hide()
    })

    $('#bcfla-imgmodal, #bcfla-imgmodal-overlay').click(function () {
        $modal.imgmodal.hide()
    })

    $('#bcfla-msg').click(function () {
        $msg.hide()
    })

    $('#bcfla-notifications .bcfla-notification-close').click(function () {
        $(this).parent().fadeOut()
    })

    $('.bcfla-table-expand-togglebtn').click(function () {
        $table.toggleExpand(this, $(this).attr('data-trclass'))
    })

    $('.bcfla-table-row2-togglebtn').click(function () {
        $table.toggleRow2Table($(this).attr('data-tableclass'))
    })

    $('.bcfla-tr-row2-toggle').click(function () {
        $table.toggleRow2Tr($(this).attr('data-trclass'))
    })

    $('.bcfla-tooltip').each(function () {
        var elem: JQuery = $(this)
        var placement = elem.attr('data-placement')
        if (!placement || placement.length === 0) placement = 'top'
        elem.tooltip({
            delay: 300,
            html: true,
            placement: placement,
        })
    })
    $('.bcfla-tooltip-click').tooltip({
        delay: 300,
        html: true,
        placement: 'top',
        trigger: 'click',
    })

    $('.bcfla-msg').each(function () {
        $(this).click(function () {
            var okmsg: string = $(this).attr('data-msg-ok')
            var errmsg: string = $(this).attr('data-msg-err')

            if (okmsg && okmsg.length > 0) $msg.show(okmsg)
            else if (errmsg && errmsg.length > 0) $msg.showError(errmsg)
        })
    })

    $('.bcfla-datepicker').datepicker({ dateFormat: 'yy-mm-dd' })

    $form.bindCheckboxEvents($('body'))
    makeUnRightClickable($('body'))

    $helpers.onCtrlAnd('s', () => {
        $('#bcfla-topnav-quicksearch input').focus()
    })

    setMenuSize()

    // show cookies disclaimer after some delay
    setTimeout(function () {
        $('#bcfla-cookiedisclaimer').addClass('open')
    }, 5000)

    $('#bcfla-cookiedisclaimer .bcfla-cookiedisclaimer__button').click(function () {
        $('#bcfla-cookiedisclaimer').removeClass('open')
        $ajax.get({ url: '/Shared/ApproveCookies', dataType: 'html' })
    })

    if (kontoId > 0) $notifications.load()
}

var isMenuExpanded: boolean = true
var scrollTreshold: number = 80

function setMenuSize(): void {
    $(document).on('scroll', function () {
        doSetMenuSize()
    })

    doSetMenuSize()
}

function doSetMenuSize(): void {
    var scrollTop: number = $(document).scrollTop()
    if (scrollTop < scrollTreshold) {
        if (isMenuExpanded) {
            return
        } else {
            $('#bcfla-topnav').addClass('bcfla-topnav-lg')
            $('#bcfla-header').addClass('bcfla-header-lgnav')
            $('#bcfla-notifications').addClass('bcfla-notifications-lgnav')
            $('#bcfla-quicksearchlist').addClass('bcfla-quicksearchlist-lgnav')
            isMenuExpanded = true
        }
    } else {
        if (!isMenuExpanded) {
            return
        } else {
            $('#bcfla-topnav').removeClass('bcfla-topnav-lg')
            $('#bcfla-header').removeClass('bcfla-header-lgnav')
            $('#bcfla-notifications').removeClass('bcfla-notifications-lgnav')
            $('#bcfla-quicksearchlist').removeClass('bcfla-quicksearchlist-lgnav')
            isMenuExpanded = false
        }
    }
}

export function onEnter(element: JQuery, callback: any): void {
    element.on('keyup', function (event: JQueryEventObject) {
        var code = event.keyCode || event.which
        if (code != 13) return
        else callback(element)
    })
}

export function onEscape(element: JQuery, callback: any): void {
    element.on('keyup', function (event: JQueryEventObject) {
        var code = event.keyCode || event.which
        if (code != 27) return
        else callback(element)
    })
}

export function onCtrlAnd(key: string, callback: any): any {
    const ev = function (e) {
        if (e.ctrlKey && e.key === key) {
            e.preventDefault()
            callback()
        }
    }

    $(window).on('keydown', ev)

    return ev
}

export function flash(element: JQuery, delay: number = 600): JQuery {
    element.css('color', 'red')

    setTimeout(() => {
        element.css('color', '')
    }, delay)

    return element
}

export function pageInDebugMode(): boolean {
    var url: string = window.location.href
    var urlarr: string[] = url.slice(url.indexOf('?') + 1).split('&')

    for (var i = 0; i < urlarr.length; i++) {
        var urlparam = urlarr[i].split('=')
        if (urlparam[0] == 'debug' && urlparam[1] == 'true') return true
    }

    return false
}

export function decodeHtml(input: string): string {
    return $('<textarea/>').html(input).text()
}

export module sidenav {
    export function show() {
        $('#bcfla-sidenav').addClass('open')
        $('#bcfla-sidenav-overlay').addClass('open')
    }

    export function hide() {
        $('#bcfla-sidenav').removeClass('open')
        $('#bcfla-sidenav-overlay').removeClass('open')
    }
}

export module scroll {
    function load(elem: JQuery, callback?: any) {
        let url = elem.attr('data-url')
        $loading.show('Laddar...')
        elem.load(url, () => {
            $loading.hide()
            if (callback) callback()
        })
        console.log('loadOnScroll: ' + url)
    }

    export function loadOnScroll(selector: string, callback?: any) {
        if ('IntersectionObserver' in window) {
            const lazyImageObserver = new IntersectionObserver(function (entries, observer) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        load($(entry.target), callback)
                        lazyImageObserver.unobserve(entry.target)
                    }
                })
            })

            $(selector).each((idx, elem) => {
                console.log('observe ' + idx + elem)
                lazyImageObserver.observe(elem)
            })
        } else {
            $(selector).each((idx, elem) => {
                console.log('load immediately ' + idx + elem)
                load($(elem), callback)
            })
        }
    }

    export function getElementTop(scrollTarget: JQuery, offset: number = 0): number {
        var elementTop = scrollTarget.offset().top

        if ($('#bcfla-topnav').length > 0) {
            elementTop -= $('#bcfla-topnav').height()
        }

        return elementTop + offset
    }

    export function scrollToElement(
        scrollTarget: JQuery,
        onlyScrollUp: boolean = false,
        offset: number = 0
    ): void {
        var documentScroll: number = $(document).scrollTop()
        var scrollTo = getElementTop(scrollTarget) + offset

        if (!onlyScrollUp || scrollTo < documentScroll) $(document).scrollTop(scrollTo)
    }

    export function elementInView(
        element: Element,
        ref?: { offset?: any; threshold?: any }
    ): boolean {
        if (ref === void 0) ref = {}
        var offset = ref.offset
        if (offset === void 0) offset = 0
        var threshold = ref.threshold
        if (threshold === void 0) threshold = 0

        var ref$1 = element.getBoundingClientRect()
        var top = ref$1.top
        var right = ref$1.right
        var bottom = ref$1.bottom
        var left = ref$1.left
        var width = ref$1.width
        var height = ref$1.height

        var intersection = {
            t: bottom,
            r: window.innerWidth - left,
            b: window.innerHeight - top,
            l: right,
        }

        var elementThreshold = {
            x: threshold * width,
            y: threshold * height,
        }

        return (
            intersection.t >= (offset.top || offset + elementThreshold.y) &&
            intersection.r >= (offset.right || offset + elementThreshold.x) &&
            intersection.b >= (offset.bottom || offset + elementThreshold.y) &&
            intersection.l >= (offset.left || offset + elementThreshold.x)
        )
    }

    export function actionWhenVisible(
        elements: JQuery,
        onEnter: (el: JQuery) => void,
        onLeave: (el: JQuery) => void,
        offset: number = 0
    ) {
        if (!elements.length) {
            return
        }

        elements.each((idx, elem) => {
            const element: JQuery = $(elem)
            let entered: boolean | null = null

            const throttledScrollCheck = _.throttle(() => {
                if (elementInView(elem, { offset })) {
                    if (!entered) {
                        onEnter(element)
                        entered = true
                    }
                } else {
                    if (entered || entered == null) {
                        onLeave(element)
                        entered = false
                    }
                }
            }, 200)

            $(window).on('scroll', () => {
                throttledScrollCheck()
            })

            throttledScrollCheck()
        })
    }

    export function hide() {
        $('#bcfla-sidenav').removeClass('open')
        $('#bcfla-sidenav-overlay').removeClass('open')
    }
}

export module pager {
    export class pagerInstance {
        private options: any
        private optionDefaults: any = {
            page: 1,
            noOfPages: 1,
            pagerId: null,
            extraData: {},
            onClick: function () {},
        }

        constructor(options: any) {
            var self = this
            self.options = $.extend(true, {}, self.optionDefaults, options)

            $('.' + self.options.pagerId + ' .bcfla-pager-btn.bcfla-btn-enabled').click(
                function () {
                    var page = $(this).attr('data-page')
                    self.options.onClick(page, self.options.extraData)
                }
            )

            $('.' + self.options.pagerId + ' .bcfla-pager-btn.bcfla-checked').click(function() {
                var input = prompt('Ange sidnummer (1–' + self.options.noOfPages + '):', self.options.page.toString())
                if (input == null) return

                input = input.trim()
                var page = Number(input)
                if (!/^[0-9]+$/.test(input) || page < 1 || page > self.options.noOfPages) {
                    $msg.showError('Ange ett heltal mellan 1 och ' + self.options.noOfPages + '.')
                    return
                }

                if (page != self.options.page) self.options.onClick(page, self.options.extraData)
            })
        }
    }
}
